import { GridApi } from 'ag-grid-community'
import objects from '../../../../../../../../../../utils/objects'

export function getWbsItemDisplayName(
  api: GridApi,
  rowIndex: number,
  prefix: string
): string {
  const node = api.getDisplayedRowAtIndex(rowIndex)
  if (!node?.data) return ''
  const wbsItem = objects.getValue(node.data, `${prefix}wbsItem`)
  return wbsItem?.displayName ?? ''
}

export function getWbsItemIconUrl(
  api: GridApi,
  rowIndex: number,
  prefix: string
): string | undefined {
  const node = api.getDisplayedRowAtIndex(rowIndex)
  if (!node?.data) return undefined
  return objects.getValue(node.data, `${prefix}wbsItem.wbsItemType.iconUrl`)
}

export function getWbsItemScheduledDate(
  api: GridApi,
  rowIndex: number,
  prefix: string
): { startDate?: string; endDate?: string } | undefined {
  const node = api.getDisplayedRowAtIndex(rowIndex)
  if (!node?.data) return undefined
  const wbsItem = objects.getValue(node.data, `${prefix}wbsItem`)
  if (!wbsItem?.scheduledDate) return undefined
  return {
    startDate: wbsItem.scheduledDate.startDate,
    endDate: wbsItem.scheduledDate.endDate,
  }
}

export const createVirtualAnchorEl = (position: {
  left: number
  top: number
}) => ({
  getBoundingClientRect: () => ({
    top: position.top,
    left: position.left,
    bottom: position.top,
    right: position.left,
    width: 0,
    height: 0,
    x: position.left,
    y: position.top,
    toJSON: () => ({}),
  }),
})
